import { GlSprintf, GlLink } from '@gitlab/ui';
import { STATUS_EMPTY } from '~/issues/constants';
import { helpPagePath } from '~/helpers/help_page_helper';
import StatusIcon from '../mr_widget_status_icon.vue';
export default {
    name: 'MRWidgetNothingToMerge',
    components: {
        GlSprintf,
        GlLink,
        StatusIcon
    },
    computed: {
        statusEmpty () {
            return STATUS_EMPTY;
        }
    },
    ciHelpPage: helpPagePath('ci/quick_start/_index.html')
};
